import Logger from '@evidentid/logger';
import Tracker from '@evidentid/tracker';

import { createModuleBuilder } from '../../app';

import AppSnackbar from './components/AppSnackbar.vue';
import { useSnackbarStore } from './store';

export function createSnackbarModule() {
    return createModuleBuilder()
        .registerTopLevelComponent(AppSnackbar)

        // Track events
        .demandContext<{ tracker?: Tracker<any>, logger?: Logger<any> }>()
        .execute((app) => {
            const snackbarStore = useSnackbarStore(app.getPinia());
            snackbarStore.$onAction(({ name, args }) => {
                if (name !== 'setSnackbarContent') {
                    return;
                }
                const content = args[0];
                const message = content?.message || null;
                const success = Boolean(content?.success);
                if (app.tracker) {
                    app.tracker.track({
                        name: message ? 'Snackbar opened' : 'Snackbar closed',
                        description: message ? `Snackbar opened (${success ? 'success' : 'error'}): ${message}` : 'Snackbar closed',
                        message,
                        success,
                    });
                }

                if (app.logger) {
                    app.logger.addBreadcrumb({
                        category: 'snackbar',
                        message: message ? `Snackbar opened: ${message}` : 'Snackbar closed',
                        data: { success },
                    });
                }
            });
        })

        .end();
}

// Compat shim: legacy callers pass a Vuex store/dispatch scope — ignored now
// that the snackbar module is a Pinia store carrying its own actions.
export const getSnackbarActions = (_scope?: unknown) => useSnackbarStore();
export type SnackbarModule = ReturnType<typeof createSnackbarModule>;
